"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCircles = exports.renderRects = void 0;
const react_1 = __importDefault(require("react"));
function renderRects(rects) {
    return rects.map(([x, y, width, height, rx], i) => react_1.default.createElement('rect', { key: `r${i}`, x, y, width, height, rx }));
}
exports.renderRects = renderRects;
function renderCircles(cs) {
    return cs.map(([cx, cy, r], i) => react_1.default.createElement('circle', { key: `c${i}`, cx, cy, r }));
}
exports.renderCircles = renderCircles;
//# sourceMappingURL=ContentLoader.utils.js.map